import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainWrapper from './MainWrapper';
import SummaryPanelPrinting from '../Summary/SummaryPanelPrinting';
import PromotionsIndex from '../PromotionsIndex/PromotionsIndex';
import ConfiguratorGuard from '../Configurator/ConfiguratorGuard';
import UnitPreview from '../Configurator/UnitPreview';

const Router = () => {
  // Create a lazy-loaded component that only loads in development
  const ClientPageTesting = React.lazy(() => {
    if (process.env.NODE_ENV !== 'production') {
      return import('../ClientPageTesting/ClientPageTesting');
    }
    return Promise.resolve({ default: () => null });
  });

  return (
    <MainWrapper>
      <main>
        <Routes>
          <Route path="/admin-unit-preview" element={<UnitPreview />} />
          {process.env.NODE_ENV !== 'production' && (
            <Route
              path="/client-page-local-testing"
              element={(
                <React.Suspense fallback={<div>Loading...</div>}>
                  <ClientPageTesting />
                </React.Suspense>
              )}
            />
          )}
          <Route path="/:promotionSlug" element={<ConfiguratorGuard />} />
          <Route
            path="/:promotionSlug/descargas"
            element={<ConfiguratorGuard />}
          />

          <Route
            path="/developments/:promotionCode/:unitCode"
            element={<ConfiguratorGuard />}
          />
          <Route path="/:promotionSlug/:code" element={<ConfiguratorGuard />} />
          <Route
            path="/:promotionSlug/:code/descargas"
            element={<ConfiguratorGuard />}
          />

          <Route
            path="/:promotionSlug/:code/summary"
            element={<SummaryPanelPrinting />}
          />
          <Route path="/" component={PromotionsIndex} />
        </Routes>
      </main>
    </MainWrapper>
  );
};

export default Router;
